// Gate off keepAlive. UCT refresh window:
// https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
export const WS_CLIENT_KEEP_ALIVE = 580000;
// Gate on: under typical 60–120s proxy idle timeouts; still inside the UCT window.
export const WS_CLIENT_LIVENESS_KEEP_ALIVE = 30000;
// Half the liveness ping interval; worst-case dead-socket detection ~45s.
export const WS_CLIENT_PONG_WAIT = 15000;
// connection_ack wait; graphql-ws closes with 4504 (retryable).
export const WS_CLIENT_CONNECTION_ACK_WAIT = 15000;
export const WS_CLIENT_RETRIES = 100;
export const WS_CLIENT_MAX_RETRY_WAIT = 30000;
// ~2h of continuous failure once waits are capped at 30s.
export const WS_CLIENT_CAPPED_RETRIES = 240;
// Hold the socket after the last sub so a quick next sub can reuse it.
export const WS_CLIENT_LAZY_CLOSE = 5000;
export const WS_CLOSE_ON_IDLE = 300000;
